<div id="impersonate-content">
    <header>
        <h3>Impersonate</h3>

        <h4>{{hello}}</h4>
    </header>

    <form>
        <sl-input class="form-control" id="username" name="username" placeholder="username" #username></sl-input>
        <button type="button" class="btn btn-warning" (click)="switch(username.value)">Switch User</button>
        <button type="button" class="btn btn-danger" (click)="exit()">Exit User</button>
    </form>
</div>
